module.exports = __webpack_public_path__ + "media/src/application/media/v2-icon-8-3feb4f9c5a44daf758dd9b1805b3efc7.svg";